var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-advance-select",
    _vm._g(
      _vm._b(
        {
          attrs: {
            multiple: _vm.multiple,
            "default-value": _vm.multiple ? "" : _vm.value,
            "default-multiple-value": _vm.multiple ? _vm.value : [],
            "callback-method-type": "value"
          },
          on: { parentCallBack: _vm.onParentCallBack }
        },
        "cargo-advance-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }